import React from 'react';
import PropTypes from 'prop-types';
import CollaborativeListDataStore from '../containers/CollaborativeListDataStore';
import ManageListNotifications from './ManageListNotifications';
import { withLocalize } from '../../Localization/withLocalize';

ListNotificationModalContent.propTypes = {
	listId: PropTypes.string,
	communityId: PropTypes.number,
	isVerticalView: PropTypes.bool,
	translate: PropTypes.func,
};

function ListNotificationModalContent({
	listId,
	communityId,
	isVerticalView,
	translate,
}) {
	return (
		<CollaborativeListDataStore listId={listId} communityId={communityId}>
			<ManageListNotifications
				listId={listId}
				isVerticalView={isVerticalView}
				translate={translate}
			/>
		</CollaborativeListDataStore>
	);
}

export default withLocalize(ListNotificationModalContent);
